//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portalUploadFile from "@/pcpage/hr/recruitment/portal/component/portalUploadFile";
export default {
  extends: portalUploadFile,
  name: "portalFileList",
  components: {},
  props: {
    showFileLists: {
      //展示列表
      type: Array,
      default: () => [],
    },
    keyval: {
      type: String,
      default: "",
    },
    deleteItem: {
      //删除编辑项
      type: String,
      default: "",
    },
    replaceItem: {
      //替换编辑项
      type: String,
      default: "",
    },
    editItem: {
      type: String,
      default: "",
    },
    fileForm: {
      type: Object,
      default: () => ({}),
    },
    delBackFunc: {
      //删除时回调函数
      type: Function,
      default: null,
    },
    uuid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      maxSize: "",
      getdoctype: "api/api/portalFile/getDocuTypeInf",
    };
  },
  methods: {
    async initFileConfig() {
      //初始化文件配置
      let url = this.getdoctype;
      if (
        this.fileForm.docutypeid == "" ||
        this.fileForm.docutypeid == undefined
      ) {
        return;
      }
      let params = {
        record: {
          btype: this.fileForm.btype,
          docutypeid: this.fileForm.docutypeid,
        },
      };
      await axios.post(url, params).then((res) => {
        if (res.data.code == "1") {
          let docuinfo = res.data.data.record.docuinfo;
          if (docuinfo != undefined) {
            if (this.isNotNullOrEmpty(docuinfo.maxsize)) {
              this.maxSize = docuinfo.maxsize + "";
            }
          }
        }
      });
    },
  },
  computed: {
    readonly: function () {
      if (this.editItem.indexOf(";" + this.deleteItem + ";") === -1) {
        //需要返回,true,设为只读
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.initFileConfig();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/portalFileList.vue